import React from 'react';
import PropTypes from 'prop-types';
import {useBrowserWidth} from '~/common/hooks/useBrowserWidth';
import {useBrowserHeight} from '~/common/hooks/useBrowserHeight';
import EnvelopeClosedBack from './assets/envelope_closed_back.png';
import EnvelopeFront from './assets/envelope_front.png';
import EnvelopeOpen from './assets/envelope_open.png';
import BalloonsSticker from './assets/generic_balloons.gif';
import Liner from './assets/liner.png';
import Stamp from './assets/stamp.png';
import {Typography} from '~library/atoms/Typography';
import {Video} from '~library/atoms/Video';

import './PremiumAnimationA.sass';

export const PremiumAnimationA = ({template, skipAnimation = false, templateMaxHeight}) => {
  const inviteContainerRef = React.useRef(null);
  const stickerContainerRef = React.useRef(null);
  const envelopeContainerRef = React.useRef(null);
  const envelopeRef = React.useRef(null);
  const yourInvitationRef = React.useRef(null);
  const templateRef = React.useRef(null);

  const browserWidth = useBrowserWidth();
  const browserHeight = useBrowserHeight();

  const [envelopeLoaded, setEnvelopeLoaded] = React.useState(false);
  const [envelopePadding, setEnvelopePadding] = React.useState();

  const envelopeAnimation = () => {
    inviteContainerRef?.current?.classList.remove('invite-container');
    inviteContainerRef?.current?.classList.add('invite-container');

    inviteContainerRef?.current?.classList.remove('step-0');
    inviteContainerRef?.current?.classList.add('step-1');

    window.setTimeout(() => {
      inviteContainerRef?.current?.classList.remove('step-1');
      inviteContainerRef?.current?.classList.add('step-2');

      window.setTimeout(() => {
        stickerContainerRef?.current?.classList.add('flipped');
      }, 200);

      window.setTimeout(() => {
        inviteContainerRef?.current?.classList.remove('step-2');
        inviteContainerRef?.current?.classList.add('step-3');

        window.setTimeout(() => {
          inviteContainerRef?.current?.classList.remove('step-3');
          inviteContainerRef?.current?.classList.add('step-4');

          let padding = 0;
          if (envelopeContainerRef.current && envelopeRef.current) {
            padding =
              (envelopeContainerRef.current.offsetHeight - envelopeRef.current.offsetHeight) / 2;
          }

          window.setTimeout(() => {
            inviteContainerRef?.current?.classList.remove('step-4');
            inviteContainerRef?.current?.classList.add('step-5');

            window.setTimeout(() => {
              inviteContainerRef?.current?.classList.remove('step-5');
              inviteContainerRef?.current?.classList.add('step-6');
              setEnvelopePadding(padding);
            }, 500);
          }, 250);
        }, 500);
      }, 800);
    }, 500);
  };

  React.useEffect(() => {
    if (!envelopeLoaded || skipAnimation) return;
    setEnvelopePadding(undefined);
    inviteContainerRef?.current?.classList.remove('reset');
    inviteContainerRef?.current?.classList.add('step-0');
    envelopeAnimation();
  }, [envelopeLoaded, skipAnimation]);

  React.useEffect(() => {
    if (envelopeContainerRef.current && envelopeRef.current) {
      setEnvelopePadding(
        (envelopeContainerRef.current.offsetHeight - envelopeRef.current.offsetHeight) / 2
      );
    }
    if (yourInvitationRef.current) {
      templateRef.current.style.width = `${yourInvitationRef.current.offsetHeight / 1.36}px`;
    }
  }, [browserWidth, browserHeight]);

  return (
    <div
      className={`invite-container variant-A ${skipAnimation ? 'step-6' : 'step-0'} fabric`}
      ref={inviteContainerRef}
    >
      <div className="invite-animation open-flap">
        <div
          className="animation-image invite-envelope__open-flap-group"
          style={{bottom: envelopePadding ? `${envelopePadding}px` : undefined}}
        >
          <img className="invite-envelope__open-flap" src={EnvelopeOpen} alt="" />
          <img className="invite-envelope__top-liner" src={Liner} alt="" />
        </div>
      </div>

      <div className="invite-animation open-bottom">
        <img
          className="animation-image invite-envelope__bottom-liner"
          src={Liner}
          style={{bottom: envelopePadding ? `${envelopePadding}px` : undefined}}
          alt=""
        />
      </div>

      <div className="invite-animation your-invitation" ref={yourInvitationRef}>
        <div className="animation-image invite-envelope__your-invitation fabric">
          <div className="invite-envelope__your-invitation__card" ref={templateRef}>
            {template.endsWith('mp4') ? (
              <Video
                src={template}
                className="fabric_user_card"
                style={{maxHeight: templateMaxHeight}}
                alt=""
              />
            ) : (
              <img
                src={template}
                className={`fabric_user_card ${envelopeLoaded ? 'ready' : ''}`}
                style={{maxHeight: templateMaxHeight}}
                alt=""
              />
            )}
          </div>
        </div>
      </div>

      <div className="invite-animation open-bottom-front" ref={envelopeContainerRef}>
        <img
          className="animation-image invite-envelope__open-bottom-front"
          src={EnvelopeOpen}
          ref={envelopeRef}
          style={{bottom: envelopePadding ? `${envelopePadding}px` : undefined}}
          alt=""
        />
      </div>

      <div className="invite-animation closed-flap">
        <div className="animation-image invite-envelope__closed-flap">
          <img className="invite-envelope__full-width" src={EnvelopeClosedBack} alt="" />
        </div>
      </div>

      <div className="invite-animation closed-front">
        <div className="animation-image invite-envelope__closed-front">
          <img
            className="invite-envelope__full-width"
            src={EnvelopeFront}
            onLoad={() => setEnvelopeLoaded(true)}
            alt=""
          />
          <img className="invite-envelope__stamp" src={Stamp} alt="" />
          <Typography variant="label2" size="large" classNames="invite-envelope__guest-name">
            Guest Name
          </Typography>
          {envelopeLoaded && (
            <div
              id="canvas__wrapper__stickers"
              className="invite-envelope__closed-front__wrapper__canvas"
              ref={stickerContainerRef}
            >
              <img className="invite-envelope__sticker" src={BalloonsSticker} alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

PremiumAnimationA.propTypes = {
  template: PropTypes.string.isRequired,
  skipAnimation: PropTypes.bool,
  templateMaxHeight: PropTypes.string,
};
